import { APP } from '../../commons/reducer';
import { createAction, createReducer } from '../../utils/reducer';
const PATH = 'woo-commerce/';

// Global constants for saga
export const SHOP = {
  GET_WOOCOMMERCE_DATA: `${PATH}GET_WOOCOMMERCE_DATA`,
  GET_WOOCOMMERCE_DATA_SUCCESS: `${PATH}GET_WOOCOMMERCE_DATA_SUCCESS`,
  GET_WOOCOMMERCE_DATA_FAILED: `${PATH}GET_WOOCOMMERCE_DATA_FAILED`,
  CREATE_WOOCOMMERCE_SHOP: `${PATH}CREATE_WOOCOMMERCE_SHOP`,
  CREATE_WOOCOMMERCE_SHOP_SUCCESS: `${PATH}CREATE_WOOCOMMERCE_SHOP_SUCCESS`,
  CREATE_WOOCOMMERCE_SHOP_FAILED: `${PATH}CREATE_WOOCOMMERCE_SHOP_FAILED`,
};

// actions
export const shopActions = {
  getShopData: createAction(SHOP.GET_WOOCOMMERCE_DATA, 'data'),
  getShopDataSuccess: createAction(SHOP.GET_WOOCOMMERCE_DATA_SUCCESS, 'data'),
  getShopDataFailed: createAction(SHOP.GET_WOOCOMMERCE_DATA_FAILED, 'data'),
  createShop: createAction(SHOP.CREATE_WOOCOMMERCE_SHOP, 'createShop'),
  createShopSuccess: createAction(SHOP.CREATE_WOOCOMMERCE_SHOP_SUCCESS, 'createShop'),
  createShopFailed: createAction(SHOP.CREATE_WOOCOMMERCE_SHOP_FAILED, 'createShop'),
};

const initialState = {
  data: null,
  errorMessage: null,
  error: false,
  loading: false,
  createShop: {
    input: {
      secret: null,
      key: null,
      domain: null
    },
  }
};

const wooCommerce = createReducer(initialState, {
  [SHOP.GET_WOOCOMMERCE_DATA](state: any) {
    state.loading = true;
  },
  [SHOP.GET_WOOCOMMERCE_DATA_SUCCESS](state: any, action: any) {
    state.loading = false;
    state.data = action.data;
  },
  [SHOP.GET_WOOCOMMERCE_DATA_FAILED](state: any, action: any) {
    state.error = true;
    state.loading = false;
    state.data = action.data
  },
  [SHOP.CREATE_WOOCOMMERCE_SHOP](state: any) {
    state.loading = true;
  },
  [SHOP.CREATE_WOOCOMMERCE_SHOP_SUCCESS](state: any, action: any) {
    state.loading = false;
    state.createShop = action.createShop
  },
  [SHOP.CREATE_WOOCOMMERCE_SHOP_FAILED](state: any, action: any) {
    state.error = true;
    state.loading = false;
    state.createShop = { output: action.data }
  },
  [APP.SERVER_FAILED](state: any) {
    state.loading = false;
  },
});

export default wooCommerce;
